<template>

      <div class="wrap inputAreaWrap">
          <div class="wrappedContent inputArea">

              <div class="narrowHeader row">
                  <div class="col-7">
                      <h2>お住まいについて</h2>
                  </div>

                  <div class="col-5 text-right">
                      <img src="@/assets/img/input/indicator_4.png" class="indicatorImg" alt="">
                  </div>
              </div>

              <div class="row">
                  <div class="col text-center">
                      <p>
                          今後お住まいを新築される際の<br>
                          ご計画をお聞かせください。
                      </p>
                  </div>
              </div>


              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label class="label-loan">ローン月額の<span class="text-nowrap">ご計画</span></label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <select v-model="osumai.loan">
                          <option :value="value" v-for="(value,index) in selectOptionsData(1, 40)" :key="index">{{value}}</option>
                      </select>
                      <span class="unit-label">万円</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label class="label-loan">ボーナス返済の<span class="text-nowrap">ご計画</span></label>
                  </div>
                  <div class="col-8 col-lg-7 text-nowrap">
                      <input type="text" inputmode="numeric" pattern="\d*" v-model="osumai.bonus" @change="osumai.bonus = zenHan($event)">
                      <span class="unit-label">万円（年額合計）</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>金利</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <div class="btnBox d-inline-block">
                          <div class="btn" :class="{ active: osumai.kinri == 0.5 }" @click="osumai.kinri = 0.5">変動 0.5%</div>
                          <div class="btn" :class="{ active: osumai.kinri == 1.0 }" @click="osumai.kinri = 1.0">固定 1.0%</div><br>
                      </div>
                      <label>自由設定<input type="text" class="ml-2 w-35" inputmode="decimal" pattern="^\d*(.\d+)?$" v-model="osumai.kinri" @change="osumai.kinri = zenHan($event)">
                          <span class="unit-label">％</span></label>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>返済期間</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <select v-model="osumai.kikan">
                          <option :value="value" v-for="(value,index) in selectOptionsData(1, kariireKikanMax)" :key="index">{{value}}</option>
                      </select>
                      <span class="unit-label">年</span><span class="unit-label sub" v-if="kariireKikanMax!=50">（返済は80歳まで）</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>借入額</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                       <input type="text" class="plaintext" readonly :value="rentalAmountLocaleString">
                      <span class="unit-label">万円 </span><span class="unit-label sub">（端数切り捨て）</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>自己資金</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <input type="text" inputmode="numeric" pattern="\d*" v-model="osumai.jikoshikin" @change="osumai.jikoshikin = zenHan($event)">
                      <span class="unit-label">万円</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>資金援助</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <input type="text" inputmode="numeric" pattern="\d*" v-model="osumai.shikinEnjo" @change="osumai.shikinEnjo = zenHan($event)">
                      <span class="unit-label">万円</span>
                  </div>
              </div>

              <div class="row">
                  <div class="col-4 col-lg-5 text-right">
                      <label>住宅購入資金</label>
                  </div>
                  <div class="col-8 col-lg-7 ">
                      <input type="text" class="plaintext" readonly :value="budgetLocaleString">
                      <span class="unit-label">万円</span>
                  </div>
              </div>

              <div class="row mt-4">
                  <div class="col input-end-text">
                      <p>これで入力は完了です！</p>
                  </div>
              </div>






              <div class="row btn-next-row mt-4">
                  <div class="col text-center">
                      <router-link to="/result" class="btn btn-outline-primary btn-next">結果へ</router-link>
                  </div>
              </div>

              <div class="row btn-prev-row">
                  <div class="col text-center">
                      <router-link to="/input3" class="btn btn-outline-primary btn-prev">戻る</router-link>
                  </div>
              </div>


          </div>
      </div>

</template>

<script>
import Calc from "@/store/calcUtil.js"
export default {
    name: "input4.vue",
    data() {
        return {
            osumai:{
                plan: 1,
                juukyohi:null,
                loan:null,
                bonus: null,
                kinri: 1.0000,
                kikan: null,
                jikoshikin: null,
                shikinEnjo: null,
            },
            kariireKikanMax: 50,
        }
    },
    computed: {
        rentalAmount() {
            return Calc.rentalAmount(this.osumai);
        },
        rentalAmountLocaleString() {
            if (this.rentalAmount === null) {
                return null;
            }
            return this.rentalAmount.toLocaleString();
        },
        budget() {
            let amount = 0;
            if (!isNaN(this.rentalAmount)) {
                amount += this.rentalAmount*1;
            }
            if (!isNaN(this.osumai.jikoshikin)) {
                amount += this.osumai.jikoshikin*1;
            }
            if (!isNaN(this.osumai.shikinEnjo)) {
                amount += this.osumai.shikinEnjo*1;
            }
            if (amount == 0) {
                return null;
            }
            return  amount;
        },
        budgetLocaleString() {
            if (this.budget === null) {
                return null;
            }
            return this.budget.toLocaleString();
        }
    },
    methods: {
        setInputsData() {
            this.$store.commit('setOsumai', this.osumai);
        },
        selectOptionsData(start, end, interval=1) {
            let options = [''];
            // console.log(interval);

            for (let i = start; i <= end; i = i+interval) {
                options.push(i);
            }

            return options;
        },
        setKariireInfo() {
            //借入期間
            this.kariireKikanMax = Calc.hensaiKikan(this.$store.state.setainushi.age);
            if (this.osumai.kikan === null) {
                this.osumai.kikan = Calc.hensaiKikanDefault(this.kariireKikanMax);
            } else if (this.osumai.kikan > this.kariireKikanMax) {
                this.osumai.kikan = this.kariireKikanMax;
            }
        },
        zenHan(e) {
            return Calc.han2Zen(e.target.value);
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.osumai = Object.assign({}, vm.osumai, vm.$store.state.osumai);
            vm.setKariireInfo();
        });
    },
    beforeRouteLeave(to, from, next) {
        this.setInputsData();
        next();
    }
}
</script>

<style lang="scss" scoped>
.plaintext:focus-visible {
    outline: none;
}
.input-end-text {
    text-align: center;

    p {
        font-weight: bold;
        font-size: 15px;
    }
}

.w-35 {
  width: 35%;
}

@media screen and (max-width: 600px) {
    .label-loan {
        line-height: 19px;
        margin-top: 0 !important;
    }
}

</style>